/**
 * Launcher for Desktop/Mobile 3rdParty games
 */

define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const core = require('core');
    const i18n = require('i18n');
    const url = require('util/url.util');
    const device = require('util/device.util');

    var base = require('modules/launcher/platforms/base.3rdParty.platform');

    module.exports = _.extend(base, {

        /**
         * Open 3rdParty game
         * @param {Object} game
         * @param {Number} mode
         */
        open: function(game, mode, options) {
            // singular changes between desktop & mobile platform
            this.provider = game.get(!device.isDesktop ? 'mobileGameType' : 'desktopGameType');
            const launchMethod = !device.isDesktop
                ? this.getLaunchOptions().launchMethodMobile
                : this.getLaunchOptions().launchMethodDesktop;
            var isRedirectInNewWindow = launchMethod === 'redirectInNewWindow';
            var gameWindow = isRedirectInNewWindow ? url.openNewWindow() : null;

            if (launchMethod === 'wrapperInThisWindow' || launchMethod === 'wrapperInNewWindow') {
                this.launch({
                    provider: this.provider,
                    game: game,
                    mode: mode,
                    gameWindow: gameWindow,
                    urlType: this.getTypeUrl(mode)?.[0]
                });

                return;
            }

            window.Playtech.API.server.getURLTemplate({
                urlTypeList: this.getTypeUrl(mode),
                clientPlatform: !device.isDesktop ? 'mobile' : 'web'
            })
                .then((launchUrl) => {
                    this.successUrlTemplateLaunch(launchUrl, gameWindow, game, mode, options);
                })
                .catch(() => {
                    this.failedUrlTemplateLaunch(gameWindow, game, options);
                });
        },

        failedUrlTemplateLaunch: function(gameWindow, game, options) {
            if (gameWindow) {
                gameWindow.close();
            }

            core.trigger('game:launch', game, false, options);

            window.Playtech.API.popup.showPopup({
                title: game.get('name') + ' ' + i18n.t('playtech.mobile.system.launcher.gameUnavailablePopup.title'),
                content: i18n.t('playtech.mobile.system.launcher.gameUnavailablePopup.desktop-content'),
                onClose: () => this.navigateFromLaunchGamePath()
            });
        },

        /**
         * Launch game after success getURLsRequest
         */
        successUrlTemplateLaunch: async function(launchUrl, gameWindow, game, mode, options) {
            if (!launchUrl) {
                this.failedUrlTemplateLaunch(gameWindow, game);
                return;
            }

            launchUrl = this.prepareLaunchUrl(launchUrl, game);

            try {
                launchUrl = await this.prepareToken(launchUrl);
            } catch (e) {
                this.failedUrlTemplateLaunch(gameWindow, game);
                return;
            }

            core.trigger('game:launch', game, true, options);

            this.launch({
                provider: this.provider,
                game: game,
                mode: mode,
                launchUrl: launchUrl,
                gameWindow: gameWindow
            });
        }
    });
});
